import { render } from "./AppCoreHeader.vue?vue&type=template&id=2029e17c"
import script from "./AppCoreHeader.vue?vue&type=script&lang=js"
export * from "./AppCoreHeader.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent01/user/2766/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ui/menu/AppCoreHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2029e17c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2029e17c', __exports__)) {
    console.log('reload')
    api.reload('2029e17c', __exports__)
  }
  
  module.hot.accept("./AppCoreHeader.vue?vue&type=template&id=2029e17c", () => {
    console.log('re-render')
    api.rerender('2029e17c', render)
  })

}


export default __exports__